module.exports = __webpack_public_path__ + "torre-eiffel.09048b520ca5a1cbc873bef643f78624.jpg";